import { requestPathname } from './routine-request-url';

/**
 * Detects the capability-grant and membership-scope requests the project Access
 * tab owns (EHQ-187).
 *
 * Matches, under `/project/{id}`:
 *  - `/grants`, `/grants/batch`, `/grants/mine`, `/grants/{grantId}`
 *  - `/users/{userId}/scopes`
 *  - `/visibility/mine`
 *
 * The Access tab reports every failure inline, next to the control that caused
 * it, because the message names a rule the admin has to act on ("cannot restrict
 * the project owner") and is only meaningful beside that control. The global
 * interceptor would add a second, vaguer report of the same failure — the same
 * duplication SCRUM-460 removed for routine triggers.
 *
 * The 403 case is the one that matters most. Adminship can be revoked while the
 * panel is open, and the global handler answers a 403 by navigating to
 * `/projects` — ripping the user out of project settings rather than letting the
 * tab fall back to its read-only view.
 */
export function isCapabilityAccessRequest(url: string): boolean {
  const path = requestPathname(url);
  return (
    /\/project\/\d+\/grants(\/(batch|mine|\d+))?$/.test(path) ||
    /\/project\/\d+\/users\/\d+\/scopes$/.test(path) ||
    /\/project\/\d+\/visibility\/mine$/.test(path)
  );
}
